import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  @font-face {
    font-family: 'Arial';
    src: local('Arial'), url('./arial.ttf');
    font-weight: normal;
  }

  @font-face {
    font-family: 'Arial';
    src: local('Arial Black'), url('./ariblk.ttf'), local('Arial');
    font-weight: bold;
  }
  
  html {
    touch-action: none;
  }
  
  body {
    background-color: #666;
    color: #eee;
    font-family: Arial, 'Arial Black', sans-serif;
    margin: 0;
    text-align: center;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    user-select: none;
    cursor: default;
  }

  code {
    font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
  }
`;
